import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/services/users.service';
import { environment } from 'src/environments/environment';
import { TemplatesFileViewertComponent } from '../shared/dialogs/templates-file-viewer/templates-file-viewer.component';

import * as JSZip from 'jszip';
import { MainService } from 'src/app/services/main.service';
import Swal from 'sweetalert2';
const fs = require('file-saver');

@Component({
  selector: 'app-media-rules',
  templateUrl: './media-rules.component.html',
  styleUrls: ['./media-rules.component.scss']
})
export class MediaRulesComponent implements OnInit {
  modules : any;
  isBuhoUsr : boolean = false;
  hostName: string = "";
  constructor(private userS: UsersService,
    private _router : Router,
    private matDialog: MatDialog,
    private main : MainService,) { 
    this.modules = this.userS.getUserModules();
    this.isBuhoUsr = (this.userS.getUser().id_rol == environment.role_buho || this.userS.getUser().id_rol == environment.role_admin_id);
    this.hostName = window.location.protocol + '//' + window.location.host;
  }

  dataRules = {
          updated : '15/10/2025',
          url: "/assets/docs/res_templates/00-CONFIGURACION_MEDIOS/CONFIGURACION_DE_MEDIOS.pdf",
          name : "CONFIGURACION_DE_MEDIOS.pdf",
          type : "pdf"   
  }

  ngOnInit(): void {
    if(!this.hasRecursos()){
      this._router.navigateByUrl('/admin/dashboard');
    }
  }

  hasRecursos(){
    return this.isBuhoUsr ? true :  this.modules.filter((e:any) => e.clave === 'recu').length > 0
  }

  openFileViewer(register : any) {
    this.matDialog.open(TemplatesFileViewertComponent, {
      panelClass: ['dialogs-md'],
      data: {
        register : register
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp.reload) {

        }
      }
    );
  }

// async downloadAll(){
//   let allLinks = this.dataMats.flatMap((item) => item.links);
//   console.log( allLinks.length );
//   var promiseValidation = 0; 
//   var zip = new JSZip();
//
//   Swal.fire({
//     icon: 'info',
//     title: 'Descargando archivos...',
//     text:'Esto puede tardar unos momentos, favor de no cerrar o recargar la pagina.',
//     allowEscapeKey: false,
//     allowOutsideClick: false,
//     showConfirmButton: false,
//     didOpen: () => {
//       Swal.showLoading();
//     }
//   });
//
//   var proccData = new Promise((resolve, reject) => {
//  
//  this.dataMats.forEach(async (x, i)=>{
//     try{
//     console.log("empezando descarga")
//     let folder = zip.folder(x.namemat);
//       x.links.forEach(async (y, i)=>{
//         await this.main.getFilefromUrl(this.hostName + y.url).then(fileA=>{
//           if(fileA){
//             folder?.file(y.name, fileA );
//             //console.log("file added")
//           }
//           promiseValidation = promiseValidation + 1; 
//           console.log(promiseValidation);
//           if (promiseValidation == allLinks.length) {
//             //console.log("fin validacion");
//             resolve("ok");
//           }
//         }); 
//       });
//       
//     }catch(ex){ 
//       console.log('error' + ex)
//       promiseValidation = promiseValidation + 1; 
//     }
//     }); 
//   });
//
//   proccData.then(x=>{
//     zip.generateAsync({ type: "blob" })
//     .then((content) => {
//       let d = new Date();
//       console.log("genero archivo para descarga...");
//       fs.saveAs(content, "TemplateDesignGeneral.zip");
//       Swal.fire({
//         icon: 'success',
//         title: 'Archivos descargados',
//         text: 'Se descargará en su navegador en unos momentos'          
//       }).then(() => {            
//        
//       });
//     });
//    })
//
// }
}
